import { gql } from '@apollo/client';
import { LinkFragment } from '@landsbankinn/shared/graphql/prismic/fragments/linkFragment';

export const navigationQuery = gql`
  ${LinkFragment}
  query nav($lang: String, $ids: [String!]) {
    allNavigations(lang: $lang, id_in: $ids) {
      edges {
        node {
          _meta {
            id
            uid
            type
            lang
          }
          title
          link {
            ...LinkFragment
          }
          visible
          body {
            ... on NavigationBody2nd_level {
              primary {
                link_text
                nav_link {
                  ...LinkFragment
                }
              }
              fields {
                third_level_link {
                  ...LinkFragment
                }
                third_level_link_text
              }
            }
          }
        }
      }
    }
  }
`;
